import React from "react";
import { Helmet } from "react-helmet";

const MetaTags = ({
  title,
  type,
  siteName,
  url,
  keywords,
  description,
  revisitAfter,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property="KALAI:title" content={title} />
      <meta property="KALAI:type" content={type} />
      <meta property="KALAI:site_name" content={siteName} />
      <meta property="KALAI:url" content={url} />
      <meta name="keywords" content={keywords} />
      <meta
        property="KALAI:description"
        name="description"
        content={description}
      />
      <meta name="robots" content="all" />
      <meta name="revisit-after" content={revisitAfter} />
      <meta name="copyright" content="KALAI Crackers" />
      <meta name="language" content="English" />
      <meta name="distribution" content="Global" />
    </Helmet>
  );
};

export default MetaTags;
